// 补足两位小数
export const padStart = (num:number, len:number) => {
  if (String(num).length > len) {
    return num;
  }
  return (Array(len).join('0') + num).slice(-len);
}
